import React, { useState, useEffect } from "react"
import { useQuery } from "@apollo/react-hooks"
import { withRouter } from "react-router"
import { Card, Label, Button, CardBody, FormGroup } from "reactstrap"
import { Spinner } from "components/spinner"
import noImage from "assets/images/no-image.jpg"
import ProductPrice from "./ProductPrice"
import { GET_PRODUCT } from "../../gql"

const ProductDetailPageCl = props => {
  const objectId = props.match.params.id
  const [quantity, setQuantity] = useState(1)
  const { data, loading } = useQuery(GET_PRODUCT, {
    skip: !objectId,
    variables: { id: objectId },
    fetchPolicy: "cache-and-network"
  })

  useEffect(() => {
    document.body.scrollTop = 0 // For Safari
    document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
  }, [])

  const selectOption = () => {
    const resultTemplate = []
    for (let i = 1; i < 100; i++) {
      resultTemplate.push(
        <option key={i} value={i}>
          {i}
        </option>
      )
    }
    return resultTemplate
  }

  if (!objectId) {
    props.history.goBack()
  }

  if (loading) {
    return <Spinner />
  }

  return (
    <Card className="product-detail">
      <CardBody>
        <div className="product-info">
          <div className="img-block">
            <img
              src={
                data?.product?.photoUrl
                  ? `http://${data.product.photoUrl}`
                  : `${noImage}`
              }
              className="img-fluid"
            />
          </div>

          <div className="info-block">
            <div className="title">
              <h3>{data?.product?.name}</h3>
            </div>
            <div className="operation-block ">
              <FormGroup>
                <Label>商品價格：</Label>
                <h4 className="mb-0">
                  <ProductPrice price={data?.product?.price} />
                </h4>
              </FormGroup>
              <FormGroup>
                <Label>商品數量</Label>
                <select
                  className="form-control"
                  value={quantity}
                  onChange={e => {
                    setQuantity(parseInt(e.target.value, 10))
                  }}
                >
                  {selectOption()}
                </select>
              </FormGroup>
              <Button
                block
                outline
                color="success"
                onClick={() => {
                  props.addToCart(objectId, quantity)
                }}
              >
                加入購物車
              </Button>
              {data?.product?.url !== "" && (
                <a
                  className="btn btn-success btn-block"
                  rel="noopener noreferrer"
                  target="_blank"
                  href={data?.product?.url}
                >
                  詳細規格連結
                </a>
              )}
            </div>
          </div>
        </div>
        <div className="product-content">{data?.product?.description}</div>
      </CardBody>
    </Card>
  )
}

export default withRouter(ProductDetailPageCl)
